class ReamazeApi {
  constructor(reamazeApiEndpoint) {
    this.reamazeApiEndpoint = reamazeApiEndpoint;
  }

  formatEndpoint(brandId = '') {
    // If URL already contains brandId (no placeholder), return as-is
    if (!this.reamazeApiEndpoint.includes('{{brandId}}')) {
      return this.reamazeApiEndpoint;
    }
    // Otherwise, replace placeholder with brandId
    return this.reamazeApiEndpoint.replace('{{brandId}}', brandId !== '' ? brandId + '.' : brandId);
  }

  /**
   * List articles with optional filtering
   * @param {string} brandId - The brand ID
   * @param {string} websiteId - The website ID
   * @param {Object} params - Query parameters
   * @param {string} params.q - Search query to filter articles by title or content
   * @param {string} params.topic_id - Filter articles by topic slug
   * @param {string} params.status - Filter by status: 'published'(0) or 'draft'(1)
   * @param {string} params.visibility - Filter by visibility: public(0), internal(1), unlisted(2)
   * @param {boolean} params.orphaned_articles - Fetch articles without topic attached
   * @param {number} params.page - Page number for pagination (default: 1)
   * @param {number} params.count_per_page - Article count per page (default: 30, max: 1000)
   * @returns {Promise} Promise resolving to articles list
   */
  listArticles(brandId, websiteId, params = {}) {
    const queryParams = new URLSearchParams();
    queryParams.append('website_id', websiteId);
    Object.keys(params).forEach(key => {
      if (params[key]) {
        queryParams.append(key, params[key]);
      }
    });
    const queryString = queryParams.toString();
    const url = `${this.formatEndpoint(brandId)}/api/v2/public/articles?${queryString}`;

    return window
      .fetch(url, {
        method: 'GET',
        credentials: 'include'
      })
      .then(res => {
        if (!res.ok) throw new Error('Failed to list articles');
        return res.json();
      });
  }

  /**
   * Get a specific article by slug
   * @param {string} brandId - The brand ID
   * @param {string} websiteId - The website ID
   * @param {string} slug - The article slug identifier
   * @returns {Promise} Promise resolving to article data
   */
  getArticle(brandId, websiteId, slug) {
    return window
      .fetch(
        `${this.formatEndpoint(brandId)}/api/v2/public/articles/${slug}?website_id=${websiteId}`,
        {
          method: 'GET',
          credentials: 'include'
        }
      )
      .then(res => {
        if (!res.ok) throw new Error('Failed to get article');
        return res.json();
      });
  }
}

export default ReamazeApi;
